export class AddOriginUrl {
  static readonly type = '[EventOrigin] Add Url';
  constructor(
    public segments: string[],
    public queryParams: Record<string, string> | undefined,
    public fragment: string | undefined
  ) {}
}
